export const maintenancePageTranslations = {
  title: 'Maintenance in Progress',
  message:
    'Our site is temporarily unavailable while we perform maintenance. Please try again later.',
};
